import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Cambia 'jwt_decode' a 'jwtDecode'
import { format, parseISO } from "date-fns";
import {es} from "date-fns/locale"; // Importa el locale español

export const renderStarRating = (rating, size) => {
  const starArray = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  // Agrega estrellas completas
  for (let i = 0; i < fullStars; i++) {
    starArray.push(
      <FaStar
        key={i}
        color="#FCBA02"
        size={size}
        style={{ marginRight: "2px", marginLeft: "2px" }}
      />,
    );
  }

  // Agrega media estrella si corresponde
  if (hasHalfStar) {
    starArray.push(
      <FaStarHalfAlt
        key="half"
        size={size}
        color="#FCBA02"
        style={{ marginRight: "2px", marginLeft: "2px" }}
      />,
    );
  }

  // Agrega estrellas vacías hasta llegar a 5
  while (starArray.length < 5) {
    starArray.push(
      <FaRegStar
        key={starArray.length}
        size={size}
        color="#EAB72B"
        style={{ marginRight: "2px", marginLeft: "2px" }}
      />,
    );
  }

  return starArray;
};

export const modal = (title, icon, button) => {
  return Swal.fire({
    title: title,
    icon: icon,
    confirmButtonText: "Aceptar",
    confirmButtonColor: "#21807C",
  });
};

export const esCorreoValido = (email) => {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
};

export const esCedulaValida = (cedula) => {
  const regex = /^\d{3}-\d{6}-\d{5}$/;
  return regex.test(String(cedula));
};


export const acortarTexto = (texto, longitud) => {
  if (texto.length > longitud) {
    return texto.substring(0, longitud) + "...";
  } else {
    return texto;
  }
};

export function formatearFecha(fecha) {
  if (!fecha) return "";

  try {
    const fechaObj = typeof fecha === "string" ? parseISO(fecha) : fecha;
    return format(fechaObj, "dd-MMM-yyyy", { locale: es }).toLowerCase(); // ej: 02-feb-2025
  } catch (e) {
    console.error("Error al formatear la fecha:", fecha, e);
    return fecha;
  }
}


export function getColorPorEstado(estado) {
  switch (estado) {
    case "multado":
      return "#d33";
    case "en ejecución":
      return "#0B545B";
    case "finalizado":
      return "#C1C1C1";
    case "aprobado":
      return "green";
    default:
      return "inherit"; // o cualquier color por defecto
  }
}

export function useGetWindowDimensions() {
  const [windowDimension, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);

  return windowDimension;
}

// Función para obtener el token almacenado en localStorage
export function getToken() {
  return localStorage.getItem("jwtToken");
}

export function jwtDecoder() {
  const token = getToken();

  if (!token) {
    return null; // No hay token en localStorage
  }

  try {
    const decodedToken = jwtDecode(token);

    // Retornar tanto el CIF/correo (sub) como el role
    return {
      sub: decodedToken.sub, // CIF o correo del usuario
      role: decodedToken.role, // Role del usuario
    };
  } catch (e) {
    console.error("Error al decodificar el token JWT:", e);
    localStorage.removeItem("jwtToken"); // Eliminar el token corrupto o inválido
    return null; // En caso de error al decodificar
  }
}

export function getAuthHeaders() {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return {};
}

export const fmtMoney = (n) =>
  (Number(n) || 0).toLocaleString("es-NI", { style: "currency", currency: "USD", minimumFractionDigits: 2 });